import { useMutation, useQuery } from '@tanstack/react-query';
import { login, logout, getUserInfo } from 'apis/authAPI';
import { useSnackbar } from 'notistack';

// Login mutation
export function useLogin(config = {}) {
	const { enqueueSnackbar } = useSnackbar();

	return useMutation({
		onError: error => {
			const message = error?.response?.data?.message || 'Something went wrong';
			enqueueSnackbar(`${message}`, {
				variant: 'error',
			});
		},
		onSuccess: () => {
			enqueueSnackbar(`Login Successfully`, {
				variant: 'success',
			});
		},
		...config,
		mutationFn: login,
	});
}

// Logout mutation
export function useLogout(config = {}) {
	return useMutation({
		...config,
		mutationFn: logout,
	});
}

// fetch the authenticated user info
export function useUser(config = {}) {
	return useQuery({
		...config,
		enabled: true,
		queryKey: ['user'],
		queryFn: () => getUserInfo(config),
	});
}
